import React from "react";
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';
import Snackbar from '@mui/material/Snackbar';
import Button from '@mui/material/Button';

export default () => {
  const [showReload, setShowReload] = React.useState(false);
  const [waitingWorker, setWaitingWorker] = React.useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  const reloadPage = () => {
    setShowReload(false);

    if (!waitingWorker) {
      window.location.reload();
      return;
    }

    // Reloading immediately after SKIP_WAITING races the worker swap: the
    // old worker is still in control, so the reloaded page serves the OLD
    // precached assets and only the next manual refresh picks up the new
    // code. Wait for the new worker to take control (the service worker
    // calls clientsClaim()), then reload exactly once.
    let reloaded = false;
    const reloadOnce = () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    };

    navigator.serviceWorker.addEventListener('controllerchange', reloadOnce, { once: true });
    // Safety net in case controllerchange never fires (e.g. the waiting
    // worker was already activated by another tab).
    setTimeout(reloadOnce, 4000);

    waitingWorker.postMessage({ type: 'SKIP_WAITING' });
  };

  React.useEffect(() => {
    serviceWorkerRegistration.register({ onUpdate: onSWUpdate });
  }, []);


  return (
    <Snackbar
      open={showReload}
      message="A new version is available!"
      onClick={reloadPage}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      action={
        <Button
          color="inherit"
          size="small"
          onClick={reloadPage}
        >
          Reload
        </Button>
      }
    />
  );
}
